<template>
  <b-modal ref="licensesModal"
           :title="$t('manage.organizations.licenses_management')"
           :ok-title="$t('save')"
           :cancel-title="$t('cancel')"
           size="lg"
           centered
           @ok.prevent="save()">

    <form>

      <!-- Number of users -->

      <div class="form-group row">
        <label for="number_of_users" class="col-4 col-form-label text-lg-right">{{ $t('manage.organizations.number_of_users') }} :</label>
        <div class="col-6">
          <input id="number_of_users" v-model.number="license.users" type="number" min="1" max="1000" class="form-control">
        </div>
      </div>

      <!-- Period of validity -->

      <div class="form-group row">
        <label class="col-4 col-form-label text-lg-right">{{ $t('manage.organizations.validity_period') }}</label>
        <div class="col-6 justify-content-between form-inline">
          <input v-model="license.validity_beginning" type="date" class="form-control" > -
          <input v-model="license.validity_ending" type="date" class="form-control" >
        </div>
      </div>

      <!-- Active -->

      <div class="form-group row">
        <label class="col-4 col-form-label text-lg-right">{{ $t('manage.organizations.active') }}</label>
        <div class="col-5">
          <Checkbox v-model="license.active"/>
        </div>
      </div>

      <!-- Amount to pay -->
      <div class="form-group row">
        <label for="amount_to_pay" class="col-4 col-form-label text-lg-right">{{ $t('manage.organizations.amount_to_pay') }} :</label>
        <div class="col-6">
          <input id="amount_to_pay" v-model.number="license.amount_to_pay" type="number" min="1" max="10000" class="form-control">
        </div>
      </div>

      <!-- Last payment amount -->
      <div class="form-group row">
        <label for="last_payment_amount" class="col-4 col-form-label text-lg-right">{{ $t('manage.organizations.last_payment_amount') }} :</label>
        <div class="col-6">
          <input id="last_payment_amount" v-model.number="license.last_payment_amount" type="number" min="1" max="10000" class="form-control">
        </div>
      </div>

      <!-- Last payment date -->
      <div class="form-group row">
        <label class="col-4 col-form-label text-lg-right">{{ $t('manage.organizations.last_payment_date') }} :</label>
        <div class="col-6 justify-content-between form-inline">
          <input v-model="license.last_payment_date" type="date" class="form-control" >
        </div>
      </div>

    </form>

  </b-modal>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'LicensesModal',

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  data: () => ({
    organization: null,
    license: {
      active: false,
      users: 1,
      validity_beginning: null,
      validity_ending: null
    }
  }),

  created () {
    const now = new Date(Date.now())
    this.validity_beginning = now.toISOString().split('T')[0]
    this.validity_ending = (now.getFullYear() + 1) + this.validity_beginning.slice(4)
  },

  methods: {
    close () {
      this.$refs.licensesModal.hide()
    },

    async save () {
      await axios.patch(`/api/organizations/${this.organization.id}/license`, this.license)
        .then((response) => this.close())
        .catch((error) => console.error(error))
    },

    async show (organization) {
      this.organization = organization

      await axios.get(`/api/organizations/${this.organization.id}/license`)
        .then((response) => this.license = response.data)
        .catch((error) => console.error(error))

      this.$refs.licensesModal.show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/LicensesModal.vue